export default __webpack_public_path__ + "static/media/powered-by-cardano.6c3cc09b.png";